export default __webpack_public_path__ + "static/media/AUTOMOTIVE_TRANSPORTATION.fd9d94a7.png";